<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col>
					<b-form-select v-model="departmentId" name="departmentId">
						<option v-for="(selectOption, indexOpt) in departments" :key="indexOpt"
							:value="selectOption.id">{{ selectOption.name }}
						</option>
						<template slot="first">
							<option :value="null" disabled>
								-- {{ $t('priceControl.departments') }} --
							</option>
						</template>
					</b-form-select>
				</b-col>
				<b-col>
					<date-picker v-model="fromDate" lang="ru" style="width: 100%"
						:placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col>
					<date-picker v-model="toDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.toDate')"
						value-type="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col cols="2">
					<b-button @click="getItems" variant="dark" class="fa fa-search mr-3" />
					<b-button @click="print" variant="outline-dark" class="fa fa-print" />
				</b-col>
			</b-row>
			<hr class="mt-4">
		</div>
		<b-card-body id="print_certificate">
			<b-row>
				<b-col cols="3">
					<div style="font-size: 10px"></div>
					<b style="font-size: 12px">{{ departmentId ? depName : '__________________' }}</b>
				</b-col>
				<b-col cols="6" align="center">
					<h6><b>{{ $t("Commodity_report_for_the_period") }}{{ $t("c") }} {{ fromDate ? fromDate : '________'
							}}
							{{ $t("po") }}
							{{ toDate ? toDate : '________' }}</b></h6>
				</b-col>
				<b-col class="text-right">
					<b style="font-size: 11px">"{{ $t("I_approve") }}"</b><br>
					<b style="font-size: 11px">{{ $t("Acting_General_Director") }}</b><br>
					<b style="font-size: 11px">DutyFree International</b>
				</b-col>
			</b-row>
			<b-row class="mt-4">
				<b-col></b-col>
				<b-col cols="7" align="right">
					_________________________________________ ___________
				</b-col>
			</b-row>
			<b-row class="mt-5 mb-4">
				<b-col>
					<table class="b-table table-hover table-striped table-bordered" id="gridContainer"
						style="font-size: 11px; width: 100%">
						<thead>
							<tr>
								<th class="text-center" style="font-size: 10px">№</th>
								<th style="font-size: 10px">{{ $t('incomes.name') }}</th>
								<th class="text-center" style="font-size: 10px">{{ $t('incomes.date') }}</th>
								<th class="text-center" style="font-size: 10px">{{ $t('Amount_in_EUR') }}</th>
								<th class="text-center" style="font-size: 10px">{{ $t('incomes.department') }}</th>
								<th class="text-center" style="font-size: 10px">{{ $t("Amount_in_UZS") }}</th>
								<th class="text-center" style="font-size: 10px">{{ $t("exchange_rate_difference") }}
								</th>
							</tr>
						</thead>
						<tbody v-if="!loading">
							<tr v-if="items.qtyAtStart">
								<td colspan="7" class="text-center">
									<strong>{{ $t("Balance_at_the_beginning") }}</strong>
								</td>
							</tr>
							<tr v-if="items.qtyAtStart">
								<td class="text-center">1</td>
								<td class="text-center"></td>
								<td class="text-center">{{ items.qtyAtStart.date }}</td>
								<td class="text-center">{{ items.qtyAtStart.sumInEur | currency({
									symbol: 'UZS',
									fractionCount:
										2, symbolPosition: 'back', thousandsSeparator: ' '
								}) }}</td>
								<td class="text-center">{{ items.qtyAtStart.department }}</td>
								<td class="text-center">{{ items.qtyAtStart.sumInUzs | currency({
									symbol: 'UZS',
									fractionCount:
										2, symbolPosition: 'back', thousandsSeparator: ' '
								}) }}</td>
								<td></td>
							</tr>
							<tr v-if="items.incomesInTerm">
								<td colspan="7" class="text-center">
									<strong>{{ $t("Income_for_the_period") }}</strong>
								</td>
							</tr>
							<tr v-if="items.incomesInTerm" v-for="(item, index) in items.incomesInTerm"
								:key="`incomesInTerm-${index}`">
								<td class="text-center">{{ index + 2 }}</td>
								<td>{{ item.docNumbers }}</td>
								<td class="text-center">{{ item.date }}</td>
								<td class="text-center">{{ item.sumInEur | currency({
									symbol: 'UZS', fractionCount: 2,
									symbolPosition: 'back', thousandsSeparator: ' '
								}) }}</td>
								<td>{{ item.fromDepartment }}</td>
								<td class="text-center">{{ item.sumInUzs | currency({
									symbol: 'UZS', fractionCount: 2,
									symbolPosition: 'back', thousandsSeparator: ' '
								}) }}</td>
								<td></td>
							</tr>
							<tr v-if="items.incomesInTerm">
								<td colspan="3" class="text-right"><b>Итого</b></td>
								<td class="text-center">{{ incomesInTermEur | currency({
									symbol: 'UZS', fractionCount: 2,
									symbolPosition: 'back', thousandsSeparator: ' '
								}) }}</td>
								<td></td>
								<td class="text-center">{{ incomesInTermUzs | currency({
									symbol: 'UZS', fractionCount: 2,
									symbolPosition: 'back', thousandsSeparator: ' '
								}) }}</td>
								<td></td>
							</tr>
							<tr v-if="items.offsInTerm">
								<td colspan="7" class="text-center">
									<strong>{{ $t("Period_expenses") }}</strong>
								</td>
							</tr>
							<tr v-if="items.offsInTerm" v-for="(item, index) in items.offsInTerm"
								:key="`offsInTerm-${index}`">
								<td v-if="items.offsInTerm.length != index + 1 && items.offsInTerm.length - 1 != index + 1"
									class="text-center">{{ index + items.incomesInTerm.length + 2 }}</td>
								<td
									v-if="items.offsInTerm.length != index + 1 && items.offsInTerm.length - 1 != index + 1">
									{{
										item.docNumbers }}</td>
								<td v-if="items.offsInTerm.length != index + 1 && items.offsInTerm.length - 1 != index + 1"
									class="text-center">{{ item.date }}</td>
								<td v-if="items.offsInTerm.length != index + 1 && items.offsInTerm.length - 1 != index + 1"
									class="text-center">{{ Math.abs(item.sumInEur) | currency({
										symbol: 'UZS',
										fractionCount: 2,
										symbolPosition: 'back', thousandsSeparator: ' '
									}) }}</td>
								<td
									v-if="items.offsInTerm.length != index + 1 && items.offsInTerm.length - 1 != index + 1">
									{{
										item.toDepartment }} <span v-if="item.sumInUzsDiff"> / {{ item.sumInUzsDiff |
										currency({
											symbol: 'UZS', fractionCount: 2, symbolPosition: 'back',
											thousandsSeparator: ' '
										}) }}</span></td>
								<td v-if="items.offsInTerm.length != index + 1 && items.offsInTerm.length - 1 != index + 1"
									class="text-center">{{ Math.abs(item.sumInUzs) | currency({
										symbol: 'UZS',
										fractionCount: 2,
										symbolPosition: 'back', thousandsSeparator: ' '
									}) }}</td>
								<td
									v-if="items.offsInTerm.length != index + 1 && items.offsInTerm.length - 1 != index + 1">
									<span v-if="item.sumInUzsDiff">{{ (item.sumInUzsDiff.toFixed(2) -
										item.sumInUzs.toFixed(2)) |
										currency({
											symbol: 'UZS', fractionCount: 2, symbolPosition: 'back',
											thousandsSeparator: ' '
										}) }}</span>
								</td>

								<td v-if="items.offsInTerm.length == index + 1" class="text-center"><i>{{ index +
									items.incomesInTerm.length + 2 }}</i></td>
								<td v-if="items.offsInTerm.length == index + 1" class="text-center"><i>{{
									item.docNumbers
										}}</i>
								</td>
								<td v-if="items.offsInTerm.length == index + 1" class="text-center"><i>{{ item.date
										}}</i>
								</td>
								<td v-if="items.offsInTerm.length == index + 1" class="text-center"><i>{{
									Math.abs(item.sumInEur)
									| currency({
										symbol: 'UZS', fractionCount: 2, symbolPosition: 'back',
										thousandsSeparator:
											' '
									}) }}</i></td>
								<td v-if="items.offsInTerm.length == index + 1" class="text-center"><i>Скидка - {{
									item.toDepartment | currency({
										symbol: 'UZS', fractionCount: 2, symbolPosition:
											'back',
										thousandsSeparator: ' '
									}) }}</i></td>
								<td v-if="items.offsInTerm.length == index + 1" class="text-center"><i>{{
									Math.abs(item.sumInUzs)
									| currency({
										symbol: 'UZS', fractionCount: 2, symbolPosition: 'back',
										thousandsSeparator:
											' '
									}) }}</i></td>
								<td v-if="items.offsInTerm.length == index + 1"><i>{{ (item.toDepartment -
									item.sumInUzs) |
									currency({
										symbol: 'UZS', fractionCount: 2, symbolPosition: 'back',
										thousandsSeparator: ' '
									}) }}</i></td>

								<td v-if="items.offsInTerm.length - 1 == index + 1" class="text-center"><i>{{ index +
									items.incomesInTerm.length + 2 }}</i></td>
								<td v-if="items.offsInTerm.length - 1 == index + 1" class="text-center"><i>{{
									item.docNumbers
								}}</i></td>
								<td v-if="items.offsInTerm.length - 1 == index + 1" class="text-center"><i>{{ item.date
								}}</i>
								</td>
								<td v-if="items.offsInTerm.length - 1 == index + 1" class="text-center"><i>{{
									Math.abs(item.sumInEur) | currency({
										symbol: 'EUR', fractionCount: 2,
										symbolPosition:
											'back', thousandsSeparator: ' '
									}) }}</i></td>
								<td v-if="items.offsInTerm.length - 1 == index + 1" class="text-center"><i>Продажа - {{
									item.toDepartment | currency({
										symbol: 'UZS', fractionCount: 2, symbolPosition:
											'back',
										thousandsSeparator: ' '
									}) }}</i></td>
								<td v-if="items.offsInTerm.length - 1 == index + 1" class="text-center"><i>{{
									Math.abs(item.sumInUzs) | currency({
										symbol: 'UZS', fractionCount: 2,
										symbolPosition:
											'back', thousandsSeparator: ' '
									}) }}</i></td>
								<td v-if="items.offsInTerm.length - 1 == index + 1"><i>{{
									(item.toDepartment - item.sumInUzs) |
									currency({
										symbol: 'UZS', fractionCount: 2, symbolPosition: 'back',
										thousandsSeparator: ' '
									}) }}</i></td>
							</tr>
							<tr v-if="items.offsInTerm">
								<td colspan="3" class="text-right"><b>{{ $t("Itogo") }}</b></td>
								<td class="text-center">{{ offsInTermEur | currency({
									symbol: 'UZS', fractionCount: 2,
									symbolPosition: 'back', thousandsSeparator: ' '
								}) }}</td>
								<td></td>
								<td class="text-center">{{ offsInTermUzs | currency({
									symbol: 'UZS', fractionCount: 2,
									symbolPosition: 'back', thousandsSeparator: ' '
								}) }}</td>
								<td></td>
							</tr>
							<tr v-if="items.saldo">
								<td class="text-center" colspan="2"><b>{{ $t("Balance_at_the_end") }}</b></td>
								<td class="text-center">{{ items.saldo.date }}</td>
								<td class="text-center">{{ items.saldo.sumInEur | currency({
									symbol: 'UZS',
									fractionCount: 2,
									symbolPosition: 'back', thousandsSeparator: ' '
								}) }}</td>
								<td class="text-left">{{ items.saldo.department }}</td>
								<td class="text-center">{{ items.saldo.sumInUzs | currency({
									symbol: 'UZS',
									fractionCount: 2,
									symbolPosition: 'back', thousandsSeparator: ' '
								}) }}</td>
								<td></td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td class="text-center" colspan="7">
									<b-spinner small class="mr-2" /><strong>Loading...</strong>
								</td>
							</tr>
						</tbody>
					</table>
					<b-button v-if="items.qtyAtStart" class="float-right mt-1 hidden-print"
						@click="excelExport1('gridContainer', 'Отчет № 31')" variant="primary" :disabled="loading">{{
							$t('excel-export.download-excel') }}</b-button>
				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import UsersService from "../../../services/users.sevice";
import { TokenService } from "../../../services/storage.service";
import ReportService from "./report.service";

export default {
	name: "Товарный отчет за период",
	components: { Multiselect },
	data() {
		return {
			items: {},
			fromDate: null,
			toDate: null,
			departments: [],
			departmentId: null,
			departmentName: '',
			loading: false
		};
	},
	computed: {
		depName() {
			this.departments.forEach(dep => {
				if (dep.id === this.departmentId) {
					this.departmentName = dep.name
				}
			})
			return this.departmentName
		},
		incomesInTermEur() {
			let sum = 0
			this.items.incomesInTerm.forEach(t => {
				sum += t.sumInEur
			})
			return sum
		},
		incomesInTermUzs() {
			let sum = 0
			this.items.incomesInTerm.forEach(t => {
				sum += t.sumInUzs
			})
			return sum
		},
		offsInTermEur() {
			let sum = 0
			this.items.offsInTerm.forEach(t => {
				if (t.sumInEur)
					sum += Math.abs(t.sumInEur)
			})
			return sum
		},
		offsInTermUzs() {
			let sum = 0
			this.items.offsInTerm.forEach(t => {
				if (t.sumInUzs)
					sum += Math.abs(t.sumInUzs)
			})
			return sum
		}
	},
	methods: {
		print() {
			const prtHtml = document.getElementById("print_certificate").innerHTML;
			let stylesHtml = "";
			for (let node of [
				...document.querySelectorAll('link[rel="stylesheet"], style'),
			]) {
				stylesHtml += node.outerHTML;
			}
			// Open the print window
			const WinPrint = window.open(
				"",
				"",
				"left=0,top=0,width=1000,height=1000,toolbar=0,scrollbars=0,status=0"
			);
			let html = `<!DOCTYPE html>
					<html>

					  <head>
					  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN" crossorigin="anonymous">
					  <style>
					body {
					  color: #000 !important;
					  align-items: flex-start;
					}
					#print_certificate {
					  display: block;
					}
					img.shadow {
					  box-shadow: none !important;
					}
						 table ,tr,td,th {
  						border: rgba(0,0,255,0.25) solid !important;
					}
					table {
             border-collapse: collapse !important;
            }
					</style>
						${stylesHtml}
					  </head>
					  <body>
						${prtHtml}

					  </body>
					</html>`;
			WinPrint.document.write(html);
			WinPrint.print();
		},
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function (s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function (s, c) {
					return s.replace(/{(\w+)}/g, function (m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		async getDeps() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
			})
		},
		async getItems() {
			this.loading = true
			if (this.departmentId && this.fromDate && this.toDate) {
				let data = {
					startDate: this.fromDate,
					endDate: this.toDate
				}
				await ReportService.getReportItems1(this.departmentId, data).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: this.$t('words.error'),
						text: e,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				})
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		}
	},
	created() {
		this.getDeps();
	},
	watch: {}
}
</script>

<style scoped lang="scss">
@page {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}

	.nav {
		display: none;
	}

	.nav-pills {
		display: none;
	}

	.flex-column {
		display: none;
	}
}
</style>
